import styles from "./MyInformationBooking.module.scss"
import Input from "../Input/Input";
import { useEffect, useState } from "react";



const MyInformationBooking = ({
    register,
    formData,
    dataContent: step2,
    setPhone,
    setContact,
    setLanguage,
    setCategories,
    setType,
    bookableBrand,
    brandId,
    setMessage,
    errorLanguage,
    errorType,
    errorPhone,
    errorContact,
    lang

}) => {
    const [optionLanguage, setOptionLanguage] = useState();
    const [optionCategories, setOptionCategories] = useState();
    const [optionType, setOptionType] = useState();

    const messageHandle = (e) => {
        setMessage(e.target.value)
    }
    const brand = bookableBrand.find((brand) => {
        if (brand.id === brandId) {
            return brand
        }
    })

    useEffect(() => {
        if (!brand) return
        const languages = brand.languages && brand.languages.split('|');
        const categories = brand.categories && brand.categories.split('|');
        const optLang = languages.map(l => ({
            label: lang[l],
            value: l
        }))
        const optCat = categories.map(l => ({
            label: lang[l],
            value: l
        }))
        const onLine = brand.online_enabled === "1" ? { label: lang['online'], value: lang['online'] } : {};
        const onSite = brand.onsite_enabled === "1" ? { label: lang['onsite'], value: lang['onsite'] } : {}
        const optType = [onSite]
        setOptionLanguage(optLang)
        setOptionCategories(optCat)
        setOptionType(optType)
        setType(optType[0].value);
    }, [brand])
    return (
        <>
            <div className={styles.containerBook}>
                <div
                    className={styles.flexBox}
                    onChange={() => { }}
                >
                    {step2.items.map((d, i) => {
                        if (i < 3) {
                            return (
                                <div
                                    className={styles.inputContainer}
                                    key={i}
                                    onClick={() => { }
                                    }
                                >
                                    <Input
                                        idCheck={d.field.id}
                                        setContact={setContact}
                                        phone={d.field.name === 'phone'}
                                        setPhone={setPhone}
                                        myinfo
                                        name={d.field.name}
                                        type={d.field.type}
                                        placeholder={d.field.placeholder}
                                        selectOptions={d.field.values ? d.field.values : null}
                                        error={d.field.error}
                                        values={d.field.values ? d.field.values : null}
                                        control={d.field.type === "date" ? control : null}
                                        biggerSelect
                                        disabled={
                                            d.field.id === "3" ||
                                                d.field.id === "1" ||
                                                d.field.id === "2"
                                                ? true
                                                : false
                                        }
                                        value={formData[d.field.name]}
                                        booking
                                        inputProps={
                                            d.field.type == "radio"
                                                ? {}
                                                : {
                                                    ...register(`${d.field.name}`, {
                                                        required: d.field.error ? true : false,
                                                        pattern:
                                                            d.field.type === "text"
                                                                ? /[a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}/
                                                                : d.field.type === "email"
                                                                    ? /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/
                                                                    : d.field.type === "number"
                                                                        ? /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/
                                                                        : null,
                                                    }),
                                                }
                                        }
                                    />
                                </div>
                            );
                        }
                        if (i >= 3 && i !== 8) {
                            return (
                                <div
                                    style={{display: d.field.id === "5" ? 'none' : 'block'}}
                                    className={styles.inputContainer}
                                    key={i}
                                    onClick={() => { }
                                    }
                                >
                                    <Input
                                        idCheck={d.field.id}
                                        setContact={setContact}
                                        setLanguage={setLanguage}
                                        setCategories={setCategories}
                                        setType={setType}
                                        setPhone={setPhone}
                                        phone={d.field.name === 'phone'}
                                        myinfo
                                        name={d.field.name}
                                        type={d.field.type}
                                        placeholder={d.field.placeholder}
                                        formatOption={
                                            d.field.id === "5" ? optionType
                                                :
                                                d.field.id === "6" ? d.field.values.map(d => ({ label: d, value: d }))
                                                    :
                                                    d.field.id === "8" ? optionCategories
                                                        :
                                                        d.field.id === "7" ? optionLanguage
                                                            :
                                                            null
                                        }
                                        values={d.field.values ? d.field.values : null}
                                        control={d.field.type === "date" ? control : null}
                                        biggerSelect
                                        value={d.field.id === "5" ? (true ? {label:'In Store', value: 'In Store'} : formData[d.field.name]): formData[d.field.name]}
                                        booking
                                        errorBookingCheck={
                                            d.field.name === "appointmenttype" ? errorType
                                                :
                                                d.field.name === "contacttype" ? errorContact
                                                    :
                                                    d.field.name === 'phone' ? errorPhone
                                                        :
                                                        d.field.name === "languagetype" ? errorLanguage
                                                            :
                                                            null
                                        }
                                        mandatory={step2.mandatory_fields}
                                    />
                                </div>
                            )
                        }
                        if (i === 8) {
                            return (

                                <label className={styles.textarea}>
                                    <textarea
                                        onChange={e => messageHandle(e)}
                                        placeholder={d.field.placeholder}
                                        type={d.field.type}
                                    />
                                </label>
                            )
                        }
                    })}

                    <div className={styles.required}>
                        {step2.mandatory_fields}
                    </div>
                </div>

            </div>
        </>
    )
}

export default MyInformationBooking;